import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
} from '@material-ui/core'
import IconCheck from '@material-ui/icons/Check'
import api from '~/api'
import track from '../../track'
import { useLiterals } from '~/components/Literals'
import snackActions from '~/actions'

const getOptions = (getLiteral) => [
  { key: 'product_not_found', text: getLiteral('1685') },
  { key: 'wrong_address', text: getLiteral('2084') },
  { key: 'wrong_phone', text: getLiteral('2085') },
  { key: 'wrong_name', text: getLiteral('2086') },
  { key: 'other', text: getLiteral('1188') },
]

export function useDialogReport(store, product, position) {
  const [state, setState] = useState({ open: false })
  const dispatcher = useDispatch()
  const { getLiteral } = useLiterals()

  const actions = useMemo(
    () => ({
      async handleSubmit(selected, other) {
        const data = { type: selected, store, product, position: position.getParams() }
        if (selected === 'other') data.text = other

        setState({ open: false })

        try {
          await api.reportProblem(data)
          dispatcher(
            snackActions.snack.add({
              id: Date.now(),
              message: getLiteral('2087'),
            }),
          )
          track('reportarProblema', { category: 'menu', name: store.name })
        } catch (error) {
          dispatcher(
            snack.add({
              id: Date.now(),
              message: `${getLiteral('1460')}: ${error.message}`,
            }),
          )
        }
      },

      handleOpen() {
        setState({ open: true })
      },

      handleCancel() {
        setState({ open: false })
      },
    }),
    [store, product, position],
  )

  return useMemo(() => ({ ...state, actions }), [state, actions])
}

function DialogReportProblem({ open, actions }) {
  const [form, setForm] = useState({ selected: null, other: '' })
  const { selected, other } = form
  const disabled = selected !== 'other' ? !selected : !selected || !other
  const { getLiteral } = useLiterals()

  const handleSelect = (key) => setForm((s) => ({ ...s, selected: s.selected === key ? null : key }))
  const handleChange = ({ target }) => setForm((s) => ({ ...s, other: target.value }))

  return (
    <Dialog open={open}>
      <DialogTitle>{getLiteral('2088')}</DialogTitle>
      <DialogContent>
        <List>
          {getOptions(getLiteral).map(({ key, text }) => (
            <React.Fragment key={key}>
              <ListItem button onClick={() => handleSelect(key)}>
                {key === selected && (
                  <ListItemIcon>
                    <IconCheck />
                  </ListItemIcon>
                )}
                <ListItemText primary={text} />
              </ListItem>
            </React.Fragment>
          ))}

          {selected === 'other' && (
            <TextField
              label={getLiteral('2089')}
              multiline
              rowsMax="4"
              value={other}
              onChange={handleChange}
              margin="normal"
              fullWidth
            />
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.handleCancel}>{getLiteral('1039')}</Button>
        <Button
          color="primary"
          variant="contained"
          disabled={disabled}
          onClick={() => actions.handleSubmit(selected, other)}
        >
          {getLiteral('1744')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogReportProblem
